import { DESK_OBJECTS, BACKGROUND_CONFIG } from './World/deskSceneConfig';
/** Build GLB sources from desk config so we don't duplicate paths */
const deskModelSources = DESK_OBJECTS.map((obj) => ({
    name: obj.id,
    type: 'gltfModel',
    path: obj.path,
}));
const backgroundSource = BACKGROUND_CONFIG && BACKGROUND_CONFIG.path !== ''
    ? [
        {
            name: 'background',
            type: 'gltfModel',
            path: BACKGROUND_CONFIG.path,
        },
    ]
    : [];
const sources = [
    ...deskModelSources,
    ...backgroundSource,
    {
        name: 'monitorSmudgeTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/smudges.jpg',
    },
    {
        name: 'monitorShadowTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/shadow-compressed.png',
    },
    {
        name: 'mouseDown',
        type: 'audio',
        path: 'audio/mouse/mouse_down.mp3',
    },
    {
        name: 'mouseUp',
        type: 'audio',
        path: 'audio/mouse/mouse_up.mp3',
    },
    {
        name: 'keyboardKeydown1',
        type: 'audio',
        path: 'audio/keyboard/key_1.mp3',
    },
    {
        name: 'keyboardKeydown2',
        type: 'audio',
        path: 'audio/keyboard/key_2.mp3',
    },
    {
        name: 'keyboardKeydown3',
        type: 'audio',
        path: 'audio/keyboard/key_3.mp3',
    },
    {
        name: 'keyboardKeydown4',
        type: 'audio',
        path: 'audio/keyboard/key_4.mp3',
    },
    {
        name: 'keyboardKeydown5',
        type: 'audio',
        path: 'audio/keyboard/key_5.mp3',
    },
    {
        name: 'keyboardKeydown6',
        type: 'audio',
        path: 'audio/keyboard/key_6.mp3',
    },
    {
        name: 'startup',
        type: 'audio',
        path: 'audio/startup/startup.mp3',
    },
    {
        name: 'office',
        type: 'audio',
        path: 'audio/atmosphere/office.mp3',
    },
    {
        name: 'ccType',
        type: 'audio',
        path: 'audio/cc/type.mp3',
    },
    {
        name: 'backgroundMusic',
        type: 'audio',
        path: 'audio/music/afternoon-jazz-lofi.mp3',
    },
];
export default sources;
